module.exports = __webpack_public_path__ + "img/icon_instagram.svg?version=ba040208";